import { ActionModal, Button, PageHeader } from 'components';
import { Form, Row, Col } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined } from '@ant-design/icons';
import InfoSection from './formSections/info';
import { useTranslation } from 'react-i18next';

import useVisitCard from '../useVisitCard';

const Edit = ({ isNew }) => {
  const { t } = useTranslation();
  const {
    form,
    updateInProcess,
    handleCreateOrUpdate,
    asset,
    leasingsManagers,
    leasingsRooms,
    leasingsContacts,
    setDisabledData,
    disabledData,
    visitTypeDisabled,
    setVisitTypeDisabled,
    showEditDataModal,
    setShowEditDataModal,
    nextVisitTypeValue,
    setNextVisitTypeValue,
    singleItem,
    leasingsMeetingTypes,
  } = useVisitCard(false);

  const onFinish = async (values) => {
    await handleCreateOrUpdate(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form.submit();
  };

  const title = isNew
    ? t('CREARE ELENCO INCONTRI')
    : t('MODIFICA ELENCO INCONTRI');

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          onFieldsChange={(changedFields) => {
            console.log('changedFields[0].name[0]=', changedFields[0].name[0]);

            if ('leasings_contact_id' === changedFields[0].name[0]) {
              console.log('changedFields[0]=', changedFields[0].value);
              const findContact = leasingsContacts.find(
                (item) => item.value === +changedFields[0].value,
              );
              form.setFields([
                {
                  name: 'company_name',
                  value: findContact?.company_title,
                  errors: [],
                },
              ]);
            }

            if (changedFields[0].name[0] === 'is_edit_data') {
              setDisabledData(!changedFields[0].value);
            }
            if (changedFields[0].name[0] === 'leasings_meeting_type_id') {
              // setDisabledData(!changedFields[0].value);
              console.log('changedFields[0].value=', changedFields[0]);
              // nextVisitTypeValue
              setNextVisitTypeValue(changedFields[0].value);
              if (
                ['credits', 'interlocutory'].includes(changedFields[0].value)
              ) {
                if (!isNew) {
                  setShowEditDataModal(true);
                  form.setFields([
                    {
                      name: 'leasings_meeting_type_id',
                      value: singleItem?.leasings_meeting_type?.id,
                    },
                  ]);
                } else {
                  setVisitTypeDisabled(true);
                }
              } else {
                setVisitTypeDisabled(false);
              }
            }
            form.setFields([
              {
                name: changedFields[0].name[0],
                errors: [],
              },
            ]);
          }}
          initialValues={{
            leasings_meeting_type_id: '',
            visit_date: '',
            title: '',
            visit_subject: '',
            visit_place: '',
            visit_persons: '',
            visit_mode: '',
            min_rent_rate: '',
            service_charge: '',
            rent_variable: '',
            rachet: '',
            break_option: '',
            contract_duration: '',
            uplift: '',
            capital_contribution: '',
            outcome_note: '',
            commercial_note: '',
            status: '',
            company_id: '',
            leasings_asset_id: '',
            leasings_manager_id: '',
            leasings_room_id: '',
            leasings_contact_id: '',
            first_file: null,
            second_file: null,
            hot_file: null,
          }}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
        >
          <InfoSection
            leasingsMeetingTypes={leasingsMeetingTypes}
            disabledData={disabledData}
            leasingsManagers={leasingsManagers}
            asset={asset}
            leasingsRooms={leasingsRooms}
            leasingsContacts={leasingsContacts}
            visitTypeDisabled={visitTypeDisabled}
          />
        </Form>
        <Row gutter={16}>
          <Col>
            <Button
              onClick={onClickSave}
              width={'150px'}
              big
              icon={<CheckOutlined />}
              loading={updateInProcess}
            >
              {t('Invia')}
            </Button>
          </Col>
        </Row>
      </div>
      {showEditDataModal && (
        <ActionModal
          title={t('Confermi la modifica?')}
          description={t(
            'Tutti i dati nelle sezione “Dati economici” e “Stato trattativa” verranno azzerati ?',
          )}
          yesBtnText={t('Si')}
          noBtnText={t('No')}
          onClickOk={() => {
            const inputNames = [
              'min_rent_rate',
              'service_charge',
              'rent_variable',
              'rachet',
              'break_option',
              'contract_duration',
              'uplift',
              'capital_contribution',
              'status',
            ];
            const fields = [
              {
                name: 'leasings_meeting_type',
                value: nextVisitTypeValue,
              },
            ];

            inputNames.forEach((name) => {
              fields.push({
                name: name,
                value: '',
              });
            });

            form.setFields(fields);
            setShowEditDataModal(false);
            setVisitTypeDisabled(true);
          }}
          onCancel={() => setShowEditDataModal(false)}
        />
      )}
    </div>
  );
};

export default Edit;
